module.exports = __webpack_public_path__ + "img/logo-100.64c407db.png";